import { render } from "./baseradiogroup.vue?vue&type=template&id=3bed9d67&scoped=true"
import script from "./baseradiogroup.vue?vue&type=script&lang=js"
export * from "./baseradiogroup.vue?vue&type=script&lang=js"

import "./baseradiogroup.vue?vue&type=style&index=0&id=3bed9d67&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bed9d67"]])

export default __exports__